import { useEffect, useMemo, useState } from "react";
import {
  normalizeTeacherAccessibility,
  resolveTeacherThemeAttribute,
  teacherTextSizeToPx,
} from "../utils/teacherAccessibility";

const DEFAULT_ACCESSIBILITY = normalizeTeacherAccessibility(null);

export function useTeacherDisplayPreferences(accessibility) {
  const normalized = useMemo(
    () => normalizeTeacherAccessibility(accessibility),
    [accessibility],
  );

  const [systemPrefersDark, setSystemPrefersDark] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    if (String(normalized.themeMode || "") !== "Auto") return undefined;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => setSystemPrefersDark(mq.matches);
    setSystemPrefersDark(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [normalized.themeMode]);

  const theme = useMemo(
    () => resolveTeacherThemeAttribute(normalized, systemPrefersDark),
    [normalized, systemPrefersDark],
  );

  useEffect(() => {
    const px = teacherTextSizeToPx(normalized.textSize);
    const root = document.documentElement;
    root.style.setProperty("--font-size", `${px}px`);
    root.style.fontSize = `${px}px`;
    return () => {
      root.style.setProperty("--font-size", "16px");
      root.style.fontSize = "16px";
    };
  }, [normalized.textSize]);

  return { theme, accessibility: normalized };
}

export { DEFAULT_ACCESSIBILITY };
